'use strict';

/* eslint-disable */

/**
 * Helper: Polyfill
 * -----------------------------------------------------------------------------
 * Loosely coupled scripts to cover features that are not native to a specific
 * browser or version.
 * 
 * Contents
 * - Array.includes
 * - Element.closest
 * - String.includes
 */

/**
 * Array.includes
 * - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/includes
 */
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function value(searchElement, fromIndex) {

      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      var len = o.length >>> 0;

      if (len === 0) {
        return false;
      }

      var n = fromIndex | 0;

      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
      }

      while (k < len) {
        if (sameValueZero(o[k], searchElement)) {
          return true;
        }
        k++;
      }

      return false;
    }
  });
}

/**
 * String.includes
 * - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
 */
if (!String.prototype.includes) {
  Object.defineProperty(String.prototype, 'includes', {
    value: function value(search, start) {
      if (typeof start !== 'number') {
        start = 0;
      }

      if (start + search.length > this.length) {
        return false;
      } else {
        return this.indexOf(search, start) !== -1;
      }
    }
  });
}

/**
 * Element.closest
 * - Return the closest ancestor of the current element.
 * - https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
 */
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (str) {
    var self = this;

    if (!document.documentElement.contains(self)) {
      return null;
    }

    do {
      if (self.matches(str)) {
        return self;
      }

      self = self.parentElement || self.parentNode;
    } while (self !== null && self.nodeType === 1);
    return null;
  };
}